import React from "react";
import { Formik, Form } from "formik";

import LdsValidationError from "../components/LdsValidationError";
import LdsTextField from "../components/LdsTextField";
import LdsButton from "../components/LdsButton";
import { StateDropDown } from "../components/StateDropDown";
import { SpecialityDropDown } from "../components/SpecialtyDropDown";

//services
import { useRegisterUserMutation } from "../store/services/authServerApi";

// import sign up validation schema
import { SignupSchema } from "../validationSchema/RegisterSchema";
import { BootstrapAlert } from "../components/BootstrapAlert";
import { forceNavigate } from "../store/utils/helper";

const RegisterForm = () => {
  console.log("* REGISTER_INIT");
  if (~~sessionStorage.getItem("companyNo") === 0) {
    forceNavigate("/login");
  }

  const [
    registerUser,
    {
      isLoading,
      error: { data: { message: errorMessage } = {} } = {},
      data: { data: token, message: successMessage } = {},
    },
  ] = useRegisterUserMutation();
  console.log(
    "isLoading, errorMessage, successMessage :>> ",
    isLoading,
    errorMessage,
    successMessage
  );

  if (token) {
    sessionStorage.setItem("token", token);
    forceNavigate("/");
  }

  const handleSubmit = ({ state, specialty, ...rest }) => {
    registerUser({ ...rest, state: state?.value, specialty: specialty?.value });
  };

  return (
    <>
      <main className="container">
        <section className="section">
          <div className="row">
            <div className="col-sm-12 col-md-8 offset-md-2">
              <h1 className="text-uppercase b">Register</h1>
              <p className="mt-4 mb-4">You are registering for information that is intended for US healthcare professionals only. By registering at this site, you certify that you are a licensed US healthcare professional. Your selected e-mail address and password will allow you to opt in or out of future Amyvid communications. For more information about Lilly's privacy practice, please view the <a className="blue clickable-link" href='https://privacynotice.lilly.com/' target='_blank' rel="noreferrer">Privacy Statement</a>.</p>
              <BootstrapAlert variant="danger" message={errorMessage} />
              <Formik
                initialValues={{
                  first: "",
                  last: "",
                  address1: "",
                  city: "",
                  state: "",
                  zipCode: "",
                  specialty: "",
                  email: "",
                  confirmEmail: "",
                  password: "",
                  confirmPassword: "",
                }}
                validationSchema={SignupSchema}
                onSubmit={handleSubmit}
              >
                {({ errors, touched }) => (
                  <Form>
                    <div className="row mb-3">
                      <div className="col-sm-12 col-md-6">
                        <LdsTextField
                          maxLength={100}
                          label="First Name"
                          labelRequired
                          name="first"
                          id="first"
                          error={errors.first && touched.first}
                        />
                        {errors.first && touched.first && (
                          <LdsValidationError id="errfirst">
                            {errors.first}
                          </LdsValidationError>
                        )}
                      </div>
                      <div className="col-sm-12 col-md-6">
                        <LdsTextField
                          maxLength={100}
                          label="Last Name"
                          labelRequired
                          id="last"
                          name="last"
                          error={errors.last && touched.last}
                        />
                        {errors.last && touched.last && (
                          <LdsValidationError id="errlast">
                            {errors.last}
                          </LdsValidationError>
                        )}
                      </div>
                    </div>

                    {/* street address */}
                    <div className="row mb-3">
                      <div className="col-sm-12">
                        <LdsTextField
                          maxLength={500}
                          label="Street Address"
                          labelRequired
                          name="address1"
                          id="address1"
                          error={errors.address1 && touched.address1}
                        />
                        {errors.address1 && touched.address1 && (
                          <LdsValidationError id="erraddress1">
                            {errors.address1}
                          </LdsValidationError>
                        )}
                      </div>
                    </div>

                    {/* city, state, zip */}
                    <div className="row mb-3">
                      <div className="col-sm-12 col-md-5">
                        <LdsTextField
                          maxLength={100}
                          label="City"
                          labelRequired
                          name="city"
                          id="city"
                          error={errors.city && touched.city}
                        />
                        {errors.city && touched.city && (
                          <LdsValidationError id="errcity">
                            {errors.city}
                          </LdsValidationError>
                        )}
                      </div>
                      <div className="col-sm-12 col-md-5">
                        <StateDropDown
                          label="State"
                          labelRequired
                          name="state"
                          error={errors?.state?.value}
                        />
                      </div>
                      <div className="col-sm-12 col-md-2">
                        <LdsTextField
                          maxLength={100}
                          label="Zip Code"
                          labelRequired
                          name="zipCode"
                          id="zipCode"
                          error={errors.zipCode && touched.zipCode}
                        />
                        {errors.zipCode && touched.zipCode && (
                          <LdsValidationError id="errzipCode">
                            {errors.zipCode}
                          </LdsValidationError>
                        )}
                      </div>
                    </div>

                    {/* primary speciality */}
                    <div className="row mb-3">
                      <div className="col-sm-12 col-md-6">
                        <SpecialityDropDown
                          label="Primary Specialty"
                          labelRequired
                          name="specialty"
                          error={errors?.specialty?.value}
                        />
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-sm-12 col-md-6">
                        <LdsTextField
                          autoComplete="new-email"
                          maxLength={100}
                          label="Email Address"
                          labelRequired
                          name="email"
                          id="email"
                          type="email"
                          error={errors.email && touched.email}
                        />
                        {errors.email && touched.email && (
                          <LdsValidationError id="erremail">
                            {errors.email}
                          </LdsValidationError>
                        )}
                      </div>
                      <div className="col-sm-12 col-md-6">
                        <LdsTextField
                          maxLength={100}
                          label="Confirm Email Address"
                          labelRequired
                          name="confirmEmail"
                          id="confirmEmail"
                          type="confirmEmail"
                          error={errors.confirmEmail && touched.confirmEmail}
                        />
                        {errors.confirmEmail && touched.confirmEmail && (
                          <LdsValidationError id="errconfirmEmail">
                            {errors.confirmEmail}
                          </LdsValidationError>
                        )}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-sm-12 col-md-6">
                        <LdsTextField
                          autoComplete="new-password"
                          maxLength={100}
                          label="Password"
                          labelRequired
                          name="password"
                          id="password"
                          type="password"
                          error={errors.password && touched.password}
                        />
                        {errors.password && touched.password && (
                          <LdsValidationError id="errpassword">
                            {errors.password}
                          </LdsValidationError>
                        )}
                      </div>
                      <div className="col-sm-12 col-md-6">
                        <LdsTextField
                          maxLength={100}
                          label="Confirm Password"
                          labelRequired
                          name="confirmPassword"
                          id="confirmPassword"
                          type="password"
                          error={
                            errors.confirmPassword && touched.confirmPassword
                          }
                        />
                        {errors.confirmPassword && touched.confirmPassword && (
                          <LdsValidationError id="errconfirmPassword">
                            {errors.confirmPassword}
                          </LdsValidationError>
                        )}
                      </div>
                      <div className="row mb-5 mt-3">
                        <div className="col-sm-4 col-md-2">
                          <LdsButton
                            disabled={isLoading}
                            type="submit"
                            className="blue-button mt-3"
                          >
                            Register
                          </LdsButton>
                        </div>
                        <p className='b mt-5'>For additional information about Lilly and other products, visit <a className="orange b clickable-link" href='https://www.lilly.com/' target='_blank' rel="noreferrer">lilly.com</a></p>
                        <p><strong>Important:</strong> The information you provide in this form will be used in accordance with the Lilly <a className="blue clickable-link" href='https://privacynotice.lilly.com/' target='_blank' rel="noreferrer">Privacy Statement</a>. You may be contacted by any of the channels provided (ie, phone, email) and that contact may come from Lilly USA, a third party operating on behalf of Lilly USA, or an Alliance Partner.</p>
                        <p className="mb-0">
                          By registering at this product site, you are
                          indicating that you wish to receive information
                          regarding this product, related training programs, and
                          other pertinent information. Lilly's intent is to only
                          provide information to healthcare professionals who
                          would likely be treating patients within the
                          FDA‑approved indications for this product. If you have
                          selected a specialty that is outside of the
                          appropriate patient population, per the FDA‑approved
                          indications for this product, you may not receive
                          information about this product.
                        </p>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </section>
        <section></section>
      </main>
    </>
  );
};

export default RegisterForm;
